import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import LoginForm from '../components/Auth/LoginForm';
import RegisterForm from '../components/Auth/RegisterForm';
import ForgotPasswordForm from '../components/Auth/ForgotPasswordForm';
import OTPVerificationForm from '../components/Auth/OTPVerificationForm';

const AuthPage = () => {
  const { t } = useTranslation();
  const [currentView, setCurrentView] = useState('login');
  const [message, setMessage] = useState('');
  const [pendingEmail, setPendingEmail] = useState('');
  const [otpNotice, setOtpNotice] = useState('');

  const handleRegistrationSuccess = (msg, email) => {
    setMessage(msg);
    setPendingEmail(email);
    setOtpNotice(t('auth.otpNotice'));
    setCurrentView('otp');
  };

  const handleForgotPasswordSuccess = (msg) => {
    setMessage(msg);
    setCurrentView('login');
  };

  const handleOTPVerified = () => {
    setMessage(t('auth.emailVerified'));
    setCurrentView('login');
    setPendingEmail('');
    setOtpNotice('');
  };

  const handleResendOTP = () => {
    setMessage(t('auth.resendCodeMessage'));
    setOtpNotice(t('auth.resendCodeNotice'));
  };

  return (
    <main className="vitria-auth">
      <Link className="vitria-auth-back" to="/">
        <ArrowBackRoundedIcon fontSize="small" />
        {t('nav.home', 'Back to Vitria')}
      </Link>

      <section className="vitria-auth-shell" aria-label={t('auth.brandName', 'Vitria')}>
        <aside className="vitria-auth-story">
          <div className="vitria-auth-brand">
            <img src={`${process.env.PUBLIC_URL}/logo192.png`} alt="" />
            <span>VITRIA</span>
          </div>

          <div className="vitria-auth-copy">
            <span>{t('auth.realTimeSecured')}</span>
            <h1>{t('auth.tagline')}</h1>
            <p>{t('auth.loginDescription')}</p>
          </div>

          <div className="vitria-auth-stats">
            <div className="vitria-auth-stat">
              <small>{t('auth.settlement')}</small>
              <strong>{t('auth.settlementDesc')}</strong>
            </div>
            <div className="vitria-auth-stat">
              <small>{t('auth.coverage')}</small>
              <strong>{t('auth.coverageDesc')}</strong>
            </div>
          </div>
        </aside>

        <div className="vitria-auth-form">
          {message && (
            <div className="mb-5 flex items-start gap-3 rounded-2xl border border-emerald-400/25 bg-emerald-400/10 p-4 text-sm text-emerald-200">
              <span className="mt-0.5 h-2 w-2 shrink-0 rounded-full bg-emerald-400" aria-hidden="true" />
              <div className="flex-1">{message}</div>
              <button
                type="button"
                onClick={() => setMessage('')}
                className="text-emerald-200/70 hover:text-emerald-100"
                aria-label={t('close', 'Close')}
              >
                ×
              </button>
            </div>
          )}

          {currentView === 'login' && (
            <LoginForm
              onSwitchToRegister={() => setCurrentView('register')}
              onSwitchToForgotPassword={() => setCurrentView('forgot')}
              onRequireOTP={(email) => {
                setPendingEmail(email);
                setOtpNotice(t('auth.verifyEmailNotice'));
                setCurrentView('otp');
              }}
            />
          )}

          {currentView === 'register' && (
            <RegisterForm
              onSwitchToLogin={() => setCurrentView('login')}
              onRegistrationSuccess={handleRegistrationSuccess}
            />
          )}

          {currentView === 'forgot' && (
            <ForgotPasswordForm
              onSwitchToLogin={() => setCurrentView('login')}
              onSuccess={handleForgotPasswordSuccess}
            />
          )}

          {currentView === 'otp' && (
            <OTPVerificationForm
              email={pendingEmail}
              notice={otpNotice}
              onVerified={handleOTPVerified}
              onResend={handleResendOTP}
              onCancel={() => setCurrentView('login')}
            />
          )}
        </div>
      </section>
    </main>
  );
};

export default AuthPage;
